module.exports = __webpack_public_path__ + "img/Web 1.17c41172.png";